import React, { useState, useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import SelectTab from '../share/SelectTab';
import Total from './total/total';
import Items from './items/items';

const JalTab = {
  TOTAL: '総数',
  ITEMS: '全件'
} as const;
export type JalTabType = keyof typeof JalTab;

const JalBooking = observer(() => {
  const history = useHistory();
  const [jalBookingTab, setJalBookingTab] = useState<JalTabType>(
    (utils.getParam('jal_booking_type') as JalTabType) ||
      (utils.getParam('jal_booking_tab') as JalTabType) ||
      'TOTAL'
  );

  useEffect(() => {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
    currentParams.set('sub_tab', 'JAL_BOOKING');
    if (!currentParams.has('jal_booking_type')) {
      currentParams.set('jal_booking_type', jalBookingTab);
    }
    history.replace(`/arrangement/todo_list?${currentParams.toString()}`);
  }, [history, jalBookingTab]);

  const handleTabChange = useCallback(
    (tab: JalTabType) => {
      setJalBookingTab(tab);
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
      currentParams.set('sub_tab', 'JAL_BOOKING');
      currentParams.set('jal_booking_type', tab);
      history.push(`/arrangement/todo_list?${currentParams.toString()}`);
    },
    [history]
  );

  return (
    <>
      <SelectTab tabs={JalTab} currentTab={jalBookingTab} onChange={handleTabChange} />
      {jalBookingTab === 'TOTAL' ? <Total /> : <Items />}
    </>
  );
});

export default JalBooking;
